import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, " Hello " + _toDisplayString(_ctx.authStoreData?.userData?.name), 1),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Home")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/services" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Services")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/contact-us" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Contact")
              ])),
              _: 1
            })
          ]),
          (_ctx.authStoreData?.isAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createElementVNode("button", {
                  class: "logout-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1),
                  _createTextVNode(" Logout ")
                ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("footer", { class: "footer" }, [
      _createElementVNode("p", null, "© 2025 Secure Ethics. All rights reserved.")
    ], -1))
  ], 64))
}